export const queryGetMainKey = (query) => query.getKey(undefined)[0];
//# sourceMappingURL=query.js.map